var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FB5B34A2-D23A-479F-BBB6-FDF1C754CBEB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Administration",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Media-Control-Bar/Entry-Selected/V1",
    transform: "translate(-64.000000, -520.000000)",
    fill: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Entry-Detail/Field-Pane/Expanded",
    transform: "translate(36.500000, 480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star",
    transform: "translate(27.500000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0 C11.3506603,0 11.6699672,0.195432771 11.8151062,0.499188357 L14.5715812,6.28269472 L21.2060975,6.99183894 C21.5544096,7.0298334 21.8470209,7.25762865 21.9561664,7.57479236 C22.0641497,7.89195608 21.968939,8.24037589 21.7100116,8.46707618 L16.7810892,12.7519597 L18.1244895,18.9745894 C18.180223,19.228086 18.1105547,19.49164 17.9375489,19.6915384 C17.7633929,19.8903132 17.5044536,20.0042194 17.2316091,19.9998831 C17.0818242,19.9975239 16.9343637,19.9584373 16.8043189,19.8880832 L11,16.7490373 L5.19569895,19.8880832 C4.8903388,20.0533635 4.51180874,20.0332627 4.22617379,19.8355971 C3.9416981,19.6390494 3.80468583,19.3029028 3.87551345,18.9745894 L5.21775158,12.7519597 L0.288829176,8.46707618 C0.0310609805,8.24036731 -0.0641496778,7.89195608 0.0438336132,7.57479236 C0.152982106,7.25762579 0.445560705,7.02980767 0.793902532,6.99183894 L7.42841876,6.28269472 L10.1848938,0.499188357 C10.3300387,0.195429912 10.6493397,0 11,0 Z",
    id: "Fill-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.839453d4ef5cd667893fa0528ff1e9bb.svg";
export { ForwardRef as ReactComponent };